import { combineReducers } from 'redux';

import transaction from './transaction';

const da = combineReducers({
    transaction,
});

export default da;
